(function () {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();

      document.querySelector(this.getAttribute('href')).scrollIntoView({
        behavior: 'smooth'
      });
    });
  });

  document.querySelectorAll('.container--img-logos').forEach(logos_wrap => {
    logos_wrap.style.marginBottom = "-"+logos_wrap.offsetHeight / 2 + "px";
    logos_wrap.style.bottom = "0";
  });


  window.addEventListener('resize', function(event) {
    document.querySelectorAll('.container--img-logos').forEach(logos_wrap => {
      logos_wrap.style.marginBottom = "-"+logos_wrap.offsetHeight / 2 + "px";
      logos_wrap.style.bottom = "0";
    });
  }, true);


  let loadingButton = document.querySelector("#show-more") || false;
  // const lnks = document.querySelectorAll('a[href*="#"]');
  const toTop = document.querySelector("#return-to-top");
  const distanceScrolled = document.documentElement.scrollTop;

  Array.from(document.querySelectorAll(".testimonail--slider")).forEach(
    (slider) => {
      new Splide(slider, {
        direction: "ltr",
        type: "loop",
        arrows: false,
        pagination: false,
        wheel: false,
        waitForTransition: true,
        wheelMinThreshold: 10,
        gap: "var(--grid-mobile-horizontal-spacing)",
        perMove: 1,
        mediaQuery: "min",
        padding: {
          left: "10%",
          right: "10%",
        },
        breakpoints: {
          750: {
            padding: {
              left: "var(--desktop-margin-left-first-item)",
              right: "var(--desktop-margin-left-first-item)",
            },
            perPage: 2,
            gap: "var(--_grid-desktop-horizontal-spacing)",
          },
          990: {
            padding: {
              left: "var(--desktop-margin-left-first-item)",
              right: "var(--desktop-margin-left-first-item)",
            },
            perPage: 3,
            gap: "var(--_grid-desktop-horizontal-spacing)",
          },
        },
      }).mount();
    }
  );

  // lnks.forEach((each) => {
  //   each.addEventListener("click", function (e) {
  //     if (!this.hasAttribute("target")) {
  //       e.preventDefault();
  //       smoothScroll(this.getAttribute("href"), 1000, 50);
  //     }
  //   });
  // });

  document.addEventListener("click", (e) => {
    if (e.target.matches('a[href*="#"]') && !e.target.hasAttribute("target")) {
      e.preventDefault();
      document
        .querySelector("sticky-header")
        .dispatchEvent(new Event("preventHeaderReveal"));
      smoothScroll(e.target.getAttribute("href"), 1000, 20);
    }
  });

  window.addEventListener("scroll", function (e) {
    if (
      window.innerWidth > 989 &&
      document.querySelector(".show-more:not(.noAuto-true)")
    ) {
      const next = loadingButton ? loadingButton.dataset.href : false;
      let article = false;
      let blog = false;

      if (
        !pollingForData(loadingButton) &&
        getDistFromBottom() <
          document.body.offsetHeight - elementPos(loadingButton) - 0
      ) {
        e.preventDefault;

        if (next) {
          if (loadingButton.classList.contains("article-load-more")) {
            article = true;
          } else if (loadingButton.classList.contains("blog-load-more")) {
            blog = true;
          }

          loadingButton.setAttribute("data-switch", "on");
          loadingButton.classList.add("loading");
          reQuest(next, loadingButton, article, blog);
        }
      }
    }

    if (!toTop) return false;

    if (distanceScrolled >= 800) {
      toTop.style.display = "block";
      setTimeout(function () {
        toTop.style.opacity = 1;
      }, 300);
    } else if (distanceScrolled < 800) {
      toTop.style.opacity = 0;
      setTimeout(function () {
        toTop.style.display = "none";
      }, 300);
    }
  });

  document.getElementById("show-more") &&
    document
      .getElementById("show-more")
      .addEventListener("click", function (e) {
        if (!pollingForData(loadingButton)) {
          const $this = this;
          let article = false;
          let blog = false;

          if ($this.classList.contains("article-load-more")) {
            article = true;
          } else if ($this.classList.contains("blog-load-more")) {
            blog = true;
          }
          workMoreButton(e, $this, article, blog);
        }
      });
})();

function workMoreButton(e, $this, article, blog) {
  var loadingButton = $this,
    next = loadingButton ? loadingButton.getAttribute("data-href") : false;

  if (!pollingForData(loadingButton) && next) {
    e.preventDefault;

    loadingButton.setAttribute("data-switch", "on");
    loadingButton.classList.add("loading");
    reQuest(next, loadingButton, article, blog);
  }
}

function reQuest(next, loadingButton, article, blog) {
  let bigWrapper = "#product-grid";

  fetch(next)
    .then((response) => response.text())
    .then((data) => {
      const doc = document.createElement("div");
      doc.innerHTML = data;

      if (article) {
        bigWrapper = ".article-template__comments";
      } else if (blog) {
        bigWrapper = ".blog-articles";
      }

      newNext = doc.querySelector(".show-more")
        ? doc.querySelector(".show-more").getAttribute("data-href")
        : false;

      const count = doc.querySelector(bigWrapper)
        ? doc.querySelector(bigWrapper).innerHTML
        : false;

      if (count) {
        const grids = Array.from(doc.querySelector(`${bigWrapper}`).children);
        const num = 1;
        const gridsNum = grids.length - 1;

        grids.forEach((grid_item, i) => {
          const para = document.createElement(grid_item.tagName);
          cloneAttributes(para, grid_item);
          para.classList.add("slide-in-bottom");
          para.style.animationDelay = `${i * 100}ms`;
          para.innerHTML = grid_item.innerHTML;

          document.querySelector(bigWrapper).appendChild(para);

          if (i < gridsNum) return false;

          loadingButton.setAttribute("data-switch", "off");

          if (!newNext) {
            loadingButton.setAttribute("data-href", false);

            document
              .querySelector("#load_more-container")
              .closest(".pagination-wrapper").style.opacity = "0";

            setTimeout(function () {
              document
                .querySelector("#load_more-container")
                .closest(".pagination-wrapper")
                .remove();
            }, 200);
          } else {
            loadingButton.setAttribute("data-href", newNext);
            loadingButton.classList.remove("loading");
          }
        });
      } else {
        return false;
      }
    })
    .then(() => {
      document.querySelector(".quick-add") &&
        Array.from(document.querySelectorAll(".quick-add")).forEach((item) =>
          item.addEventListener("click", (e) => e.stopPropagation())
        );
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

function pollingForData(item) {
  return item.dataset.switch == "off" ? false : true;
}

function smoothScroll(targetEl, duration, exact) {
  let target = document.querySelector(targetEl);
  let targetPosition = target.getBoundingClientRect().top - exact;
  let startPosition = window.pageYOffset;
  let startTime = null;

  const ease = function (t, b, c, d) {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  };

  const animation = function (currentTime) {
    if (startTime === null) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const run = ease(timeElapsed, startPosition, targetPosition, duration);
    window.scrollTo(0, run);
    if (timeElapsed < duration) requestAnimationFrame(animation);
  };

  requestAnimationFrame(animation);
}

function cloneAttributes(target, source) {
  [...source.attributes].forEach((attr) => {
    target.setAttribute(attr.nodeName, attr.nodeValue);
  });
}

function removeItem(array, item) {
  for (var i in array) {
    if (array[i].id == item) {
      array.splice(i, 1);
      break;
    }
  }
}
